export const en = {
    "k_a8b6fae2": "Wait for the page slice to complete rendering",
    "k_a1296606": "This method can ensure that subsequent logical page slices are rendered complete",
    "k_eed42cbc": "The page type added is wrong!",
    "k_54cc4995": "Low-code page",
    "k_6f3a5623": "Quickly build pages using visual editors",
    "k_812778d1": "AI page",
    "k_56b1cc32": "Let AI generate page content and interaction through dialogue",
    "k_c6f68f1b": "Local development page",
    "k_e0871a05": "Develop and publish pages locally with CLI tools",
    "k_db11b1a5": "Please preview it on the custom domain name product end",
    "k_4e3cd06d": "Test version failed to load",
    "k_a5866f2b": "Preparing the AI page development environment",
    "k_f5f44245": "Stable version (stable)",
    "k_c059f600": "Current page address:{arg_0}",
    "k_530f9d66": "Error time:{arg_0}",
    "k_e907bac4": "Copy to clipboard",
    "k_206be49d": "Select editor version",
    "k_6bd0be7e": "Please try selecting a new version, or copy the following information and contact the assistant:",
    "k_ef6f61bc": "Click to copy",
    "k_c485050b": "Invalid",
    "k_310d2b1": "After selection, editor resources will be reloaded and invalid versions will be disabled",
    "k_223445e": "[customRequire]{arg_0} is not implemented",
    "k_f07e8318": "Unable to find configuration for data source \"{arg_0}\"",
    "k_e8a23bc9": "Don't have permission to call, click",
    "k_12c4e2b4": "Try connecting to the editor…",
    "k_acd2622b": "Page not built completely",
    "k_135b2844": "Please contact the developer",
    "k_7439aa4b": "Loading dependent modules…",
    "k_885a1da": "External dependency loading failed",
    "k_d9797c74": "Please refresh and try again, or contact the developer to republish",
    "k_67415b6": "Global context"
};
